import { createEconnectorClient, UnpagedSearchOperation, unpagedSearchRequestFactory } from '@infuse/api/common';
import { ConnectedDevices, StatisticMessage } from './model';

const client = createEconnectorClient('/api/stats');

export const statisticsPermissions = {
  GET_DEVICE_STATS: 'econnector.get-device-statistics',
  GET_MESSAGE_STATS: 'econnector.get-message-statistics'
};

export const getStatisticMessages: UnpagedSearchOperation<StatisticMessage[]> = unpagedSearchRequestFactory<StatisticMessage[]>(client, {
  pattern: '/messages',
  permissionId: statisticsPermissions.GET_MESSAGE_STATS
});
export const getConnectedDevices: UnpagedSearchOperation<ConnectedDevices> = unpagedSearchRequestFactory<ConnectedDevices>(client, {
  pattern: '/devices',
  permissionId: statisticsPermissions.GET_DEVICE_STATS
});